import React from 'react'
import classNames from 'classnames'
import styles from './SaleValue.module.scss'

const SaleValue = ({ value, asterisk = false, className = '', isCampaign }) => {
  return (
    <strong
      className={classNames(styles.span, className, {
        [styles.campaign]: isCampaign,
      })}
    >
      {value
        ? `R$ ${parseInt(value, 10).toLocaleString('pt-br')}`
        : 'Sob consulta'}
      {asterisk && value ? '*' : ''}
    </strong>
  )
}

export default React.memo(SaleValue)
